import { Injectable } from '@angular/core';
import { Address } from '../../../../../../models/order/workflow/credit-check.model';
import { PreviousAddressData } from '../../../../../../models/order/workflow/previous-address.model';
import { BaseWorkflowStateService } from '../base-workflow-state.service';



@Injectable({ providedIn: 'root' })
export class PreviousAddressStateService extends BaseWorkflowStateService<PreviousAddressData> {
    protected override stateKey: string = 'previousAddress';

    setPreviousAddress(value: Address) {
        this.updateData({
            address: value
        });
    }
}